import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import { IFinanceQuote } from '../../../../../../../common/model/IFinanceQuote';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../../store/selectors/currentDealSelectors';
import Translation from '../../../../../../../common/components/translation/Translation';

const ChosenTermContainer: FC = () => {
  const duration: IFinanceQuote = useSelector(currentDealSelectors.getFinanceQuoteDuration);

  return (
    <Rate
      labelId={RateTypes.PAYMENT_TERM}
      value={<Translation values={{ value: +duration ?? 0 }} id="spc.customise.footer.finance.monthsValue" />}
    />
  );
};

export default ChosenTermContainer;
